<template>
  <div class="page-container">
    <h4 class="mb-4">Generowanie nowego raportu</h4>
    <b-form @submit.prevent="generate">
      <b-form-group id="dates" label="Wybierz zakres czasowy:">
        <div class="datepicker-trigger">
          <div class="datepicker__wrapper">
            <input
              id="datepicker-trigger"
              type="text"
              style="width: 100%; height: 50px; position: absolute; opacity: 0;"
            />
            <div class="datepicker__dummy-wrapper">
              <div tabindex="0" class="datepicker__input">Od {{ dateOne }}</div>
              <div tabindex="-1" class="datepicker__input">Do {{ dateTwo }}</div>
            </div>
          </div>

          <AirbnbStyleDatepicker
            :trigger-element-id="'datepicker-trigger'"
            :mode="'range'"
            :fullscreen-mobile="true"
            :date-one="dateOne"
            :date-two="dateTwo"
            @date-one-selected="
              val => {
                dateOne = val
              }
            "
            @date-two-selected="
              val => {
                dateTwo = val
              }
            "
          />
        </div>
        <hotel-date-picker v-show="false" />
      </b-form-group>
      <b-form-group id="places" label="W raporcie uwzględnij zaznaczone placówki:">
        <b-form-checkbox-group v-model="scopes" :options="$store.state.userInfo.api_keys">
        </b-form-checkbox-group>
      </b-form-group>
      <b-form-group id="include-categories" label="W raporcie uwzględnij wizyty:">
        <b-form-checkbox-group v-model="include">
          <b-form-checkbox value="success" class="text-success">Zarejestrowane</b-form-checkbox>
          <b-form-checkbox value="unconfirmed" class="text-secondary"
            >Niepotwierdzone</b-form-checkbox
          >
          <b-form-checkbox value="failed" class="text-danger">Niezarejestrowane</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-button block variant="primary" type="submit">
        <div v-if="!generating">
          Generuj raport <font-awesome-icon icon="box"></font-awesome-icon>
        </div>
        <b-spinner v-else variant="light" type="grow" label="Spinning"></b-spinner>
      </b-button>
    </b-form>
    <div style="line-height: 60px;">
      <div class="float-left">
        <h4 class="mt-4">Historia wygenerowanych raportów</h4>
      </div>
      <div class="float-right">
        <b-button variant="primary"
          >Pobierz zaznaczone <font-awesome-icon icon="cloud-download-alt"></font-awesome-icon
        ></b-button>
      </div>
    </div>
    <b-table
      striped
      hover
      :items="listOfReports.data"
      :fields="listOfReports.fields"
      selectable
      select-mode="multi"
      @row-selected="rowSelected"
    ></b-table>
  </div>
</template>

<script>
import HotelDatePicker from 'vue-hotel-datepicker'

export default {
  props: ['scope'],
  methods: {
    generate() {},
    rowSelected(items) {
      this.listOfReports.selected = items
    }
  },
  data() {
    return {
      include: ['success'],
      scopes: [this.scope],
      generating: false,
      dateFormat: 'D MMM',
      dateOne: '',
      dateTwo: '',
      plPL: {
        night: 'Dzień',
        nights: 'Dni',
        'day-names': ['Niedz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
        'check-in': 'Od',
        'check-out': 'Do',
        'month-names': [
          'Styczeń',
          'Luty',
          'Marzec',
          'Kwiecień',
          'Maj',
          'Czerwiec',
          'Lipiec',
          'Sierpień',
          'Wrzesień',
          'Październik',
          'Listopad',
          'Grudzień'
        ]
      },
      listOfReports: {
        fields: [
          {
            key: 'created_at',
            sortable: true,
            label: 'Data wygenerowania'
          },
          {
            key: 'range',
            sortable: false,
            label: 'Zakres dat'
          },
          {
            key: 'password',
            sortable: false,
            label: 'Hasło'
          }
        ],
        data: [
          {
            created_at: '2019-04-07',
            range: '2019-01-01 - 2019-02-01',
            password: 'sj3dn5',
            link: 'dasdas'
          }
        ],
        selected: []
      }
    }
  },
  components: {
    HotelDatePicker
  }
}
</script>

<style scoped></style>
